import { render, staticRenderFns } from "./multiple-editor.vue?vue&type=template&id=30a47068&scoped=true&"
import script from "./multiple-editor.vue?vue&type=script&lang=js&"
export * from "./multiple-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a47068",
  null
  
)

export default component.exports